import React from 'react';

const HeroSection = ({ sectionRef, scrollToSection, translations }) => {
  const t = translations;

  return (
    <section 
      ref={sectionRef} 
      className="relative h-[50vh] overflow-hidden"
      style={{
        backgroundImage: `url('/hero_section.png')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      {/* Overlay for better text readability */}
      <div className="absolute inset-0 bg-black/30"></div>
      
      

      <div className="relative z-10 flex items-center justify-center h-full text-center px-4 pt-16">
        <div className="max-w-2xl mx-auto text-white">
          <h1 className="text-4xl md:text-6xl font-bold mb-3 animate-pulse-slow drop-shadow-2xl">
            {t.heroTitle}
          </h1>
          <h2 className="text-lg md:text-2xl mb-4 font-light drop-shadow-xl">
            {t.heroSubtitle}
          </h2>
          <p className="text-sm md:text-base mb-6 max-w-lg mx-auto leading-relaxed drop-shadow-lg">
            {t.heroDescription}
          </p>
          <button
            onClick={() => scrollToSection('contact')}
            className="bg-white text-pink-600 px-5 py-2.5 rounded-full text-sm font-semibold hover:shadow-lg transform hover:scale-105 transition-all duration-300"
          >
            {t.getQuote} ✨
          </button>
        </div>
      </div>

      
    </section>
  );
};

export default HeroSection;